module.exports = __webpack_public_path__ + "img/oups.32e26807.png";